import React from "react";
import { BASE_URL } from "../../constants";

const IntegratedPlanning = () => {
  return (
    <div className="inteplancontainer">
      <h1 className="inteplanheading">
        INTEGRATED PLANNING <br />
        AND ANALYSIS
      </h1>
      <p className="inteplansubheading">
        One Single platform to analyze from Planning to Operations
      </p>
      <div className="inteplangrid">
        <div className="inteplancard1">
          <h3 className="forecast">Forecasts</h3>
          <p>
            Predict and optimize your NetZero initiatives with unparalleled
            precision.
          </p>
        </div>
        <div className="inteplancard2">
          <h3 className="eco">Economics</h3>
          <p>
            Assess financial viability with in-depth cost analysis and risk
            evaluation.
          </p>
        </div>
        <div className="inteplanimagecontainer">
          <img
            src={`${BASE_URL}integrated_ planning/integrated_planning.png
`}
            alt="Integrated Planning"
            className="inteplanimage"
          />
        </div>
        <div className="inteplancard3">
          <h3 className="insight">Actionable Insights</h3>
          <p>
            Turn complex data into clear, strategic decisions for optimized
            performance.
          </p>
        </div>
        <div className="inteplancard4">
          <h3 className="recommend">Recommendations</h3>
          <p>
            Receive AI-powered, data-backed suggestions to improve efficiency
            and sustainability.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IntegratedPlanning;
